import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

let echoSingleton = null;

export function getEcho() {
  if (echoSingleton) return echoSingleton;

  const key = process.env.REACT_APP_REVERB_APP_KEY;
  const host = process.env.REACT_APP_REVERB_HOST;
  const apiRoot = process.env.REACT_APP_API_ROOT;

  const scheme = (process.env.REACT_APP_REVERB_SCHEME || "https").toLowerCase();
  const useTLS = scheme === "https";

  const wsPort = Number(process.env.REACT_APP_REVERB_PORT || 80);
  const wssPort = Number(process.env.REACT_APP_REVERB_WSS_PORT || 443);

  // Guard: if required env vars are missing, log an error and return null.
  // This prevents the app from attempting to use Echo and failing silently.
  if (!key || !host || !apiRoot) {
    console.warn("Echo not initialized: missing env", {
      hasKey: Boolean(key),
      hasHost: Boolean(host),
      hasApiRoot: Boolean(apiRoot),
    });
    return null;
  }

  echoSingleton = new Echo({
    broadcaster: "reverb",
    key,

    wsHost: host,
    forceTLS: useTLS,

    wsPort: useTLS ? undefined : wsPort,
    wssPort: useTLS ? wssPort : undefined,

    authEndpoint: `${apiRoot}/api/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: "", // Will be set by setEchoAuthToken before subscribing
      },
    },
  });

  window.Echo = echoSingleton;
  return echoSingleton;
}

export function resetEcho() {
  try {
    echoSingleton?.disconnect();
  } catch {}
  echoSingleton = null;
  try {
    delete window.Echo;
  } catch {
    window.Echo = undefined;
  }
}
